import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "SelectPossibleDatesModal" }
const _hoisted_2 = {
  key: 0,
  class: "h20"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "fw600 fs16 alert-warning pad20" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "fl"
}
const _hoisted_8 = {
  key: 0,
  class: "fs18 mt8"
}
const _hoisted_9 = {
  key: 1,
  class: "fs16"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "可能な日程を", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "fs28 fw600 arial" }
const _hoisted_14 = { class: "fl" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  key: 2,
  class: "fr",
  style: {}
}
const _hoisted_17 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`fr centered circle_button lgreyBg fs14 rad8 fw600`),
  style: {"width":"180px","height":"44px","padding":"11px 8px","margin-top":"-3px"}
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "fs9"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  key: 2,
  style: {"margin-top":"12px","margin-right":"8px"},
  class: "fr fw600 fs14 dgrey"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "fs16 arial" }
const _hoisted_25 = {
  key: 1,
  class: ""
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = {
  key: 1,
  class: "llgreyBg w100 pad10 rad8"
}
const _hoisted_28 = { class: "fl fs11 fw600 ddgrey" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = {
  class: "posAb",
  style: {"right":"0","bottom":"10px"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = {
  key: 2,
  class: "submitButton centered z1"
}
const _hoisted_37 = {
  key: 0,
  class: "lgreyBg",
  style: {"height":"68px"}
}
const _hoisted_38 = {
  key: 0,
  class: "fs20 arial"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "fs16 arial" }
const _hoisted_43 = {
  key: 1,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LblueListContent = _resolveComponent("LblueListContent")!
  const _component_PossibleDatesWithCalendarTable = _resolveComponent("PossibleDatesWithCalendarTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
              width: "30",
              height: "30",
              class: "fr pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideSelectPossibleDatesModal && _ctx.hideSelectPossibleDatesModal(...args)))
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isObserver)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "あなたはオブザーバーです。日程の確認のみできます。"))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.rs && _ctx.Util.isPresent(_ctx.rs.vote_warning_text))
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.rs.vote_warning_text), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _hoisted_10,
                    (
                                _ctx.pdm.owner_request_num <= 0 ||
                                (_ctx.pdm && _ctx.pdm.owner_request_num * 2 > (_ctx.pdm.possibleDates?.length || 0))
                            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " できるだけ多く "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createTextVNode(" 最低"),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.pdm.owner_request_num), 1),
                          _createTextVNode("件 ")
                        ])),
                    _createTextVNode(" 選択してください。 ")
                  ])),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t(`schedule.select_dates`, { request_num: _ctx.pdm.owner_request_num })), 1),
              _hoisted_15
            ])),
        (!_ctx.isSP && !_ctx.isObserver)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 提案しています "))
                : (!_ctx.pdm.canFix && _ctx.Util.isPresent(_ctx.selectedPossibleDates))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(`fr pointer centered circle_button ${_ctx.isPreview ? `lgreyBg` : `pinkBg`} fs14 rad8 fw600`),
                      style: {"width":"180px","height":"44px","padding":"11px 8px","margin-top":"-3px"},
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.suggestDates && _ctx.suggestDates(...args)))
                    }, [
                      (_ctx.selectedPossibleDates)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t(`schedule.suggest_schedules`, { num: (_ctx.selectedPossibleDates || []).length })), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isPreview)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode("(プレビューのため提案不可)")
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
              (!_ctx.pdm.canFix && _ctx.selectedPossibleDates.length > 0 && _ctx.pdm.owner_request_num != -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_ctx.pdm && _ctx.pdm.owner_request_num * 2 < _ctx.pdm.possibleDates.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_ctx.pdm.owner_request_num - _ctx.selectedPossibleDates.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createTextVNode(" 残り"),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.pdm.owner_request_num - _ctx.selectedPossibleDates.length), 1),
                                _createTextVNode("件 ")
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t(`schedule.can_suggest`)), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_26
      ]),
      (_ctx.Util.isPresent(_ctx.selectedPossibleDates))
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", {
              class: _normalizeClass(`posRe ${_ctx.displayAll ? `` : `ofh`}`),
              style: _normalizeStyle({ height: _ctx.displayAll ? `` : `45px` })
            }, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t(`schedule.selecting`)), 1),
              _hoisted_29,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPossibleDates, (pd, pdindex) => {
                return (_openBlock(), _createBlock(_component_LblueListContent, {
                  class: "fl mr5 mb5",
                  key: `${pdindex}${pd.start_time}${_ctx.systemUpdatedAt}`,
                  name: `${_ctx.DateTime.fromSeconds(pd.start_time).toFormat(_ctx.$t('calendar.format_short_datetime'))}~`,
                  type: "circle",
                  showDeleteButton: true,
                  display: true,
                  value: pd.start_time,
                  onDeleteContent: ($event: any) => (_ctx.returnDate(pd, `remove`))
                }, null, 8, ["name", "value", "onDeleteContent"]))
              }), 128)),
              _createElementVNode("div", _hoisted_30, [
                (_ctx.selectedPossibleDates.length > 3)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fs11 fw600 ddgrey pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayAll = !_ctx.displayAll))
                    }, _toDisplayString(_ctx.displayAll ? _ctx.$t(`schedule.hide`) : _ctx.$t(`schedule.show_all`)), 1))
                  : _createCommentVNode("", true),
                _hoisted_31
              ]),
              _hoisted_32
            ], 6),
            _hoisted_33
          ]))
        : _createCommentVNode("", true),
      _hoisted_34,
      _hoisted_35,
      _createVNode(_component_PossibleDatesWithCalendarTable, {
        ref: "PossibledatesWithCalendarTable",
        idprefix: `sel`,
        showConfirmButton: false,
        useSelectbox: true,
        astag: _ctx.astag,
        loading: _ctx.loading,
        getPossiblesWithMonth: _ctx.getPossiblesWithMonth,
        getPossiblesWithWeek: _ctx.getPossiblesWithWeek,
        calendarShowType: _ctx.calendarShowType()
      }, null, 8, ["astag", "loading", "getPossiblesWithMonth", "getPossiblesWithWeek", "calendarShowType"]),
      (_ctx.isSP && !_ctx.isObserver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            (_ctx.isPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, "プレビューのため、確定できません"))
              : _createCommentVNode("", true),
            (!_ctx.pdm.canFix && _ctx.selectedPossibleDates.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  id: "roomCloseButton",
                  class: _normalizeClass(`whiteColor pointer ${_ctx.isSP ? `` : `w60 fs20`} pinkBg`),
                  style: {"height":"68px"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.suggestDates && _ctx.suggestDates(...args)))
                }, [
                  (_ctx.selectedPossibleDates)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t(`schedule.suggest_schedules`, { num: (_ctx.selectedPossibleDates || []).length })), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.pdm.canFix && _ctx.selectedPossibleDates.length > 0 && _ctx.pdm.owner_request_num != -1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                        (_ctx.pdm && _ctx.pdm.owner_request_num * 2 < _ctx.pdm.possibleDates.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              (_ctx.pdm.owner_request_num - _ctx.selectedPossibleDates.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createTextVNode(" 残り"),
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.pdm.owner_request_num - _ctx.selectedPossibleDates.length), 1),
                                    _createTextVNode("件 ")
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t(`schedule.can_suggest`)), 1))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}